/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Shop the Look: gesamte Produktkachel anklickbar machen
  // product-grid-item verlinkt nur Bild und Titel separat — Klicks auf den
  // Kartenhintergrund landen ins Leere. Dieser Handler navigiert zur Produkt-URL
  // (aus data-url am grid-item), sofern nicht auf einen Link/Button geklickt wurde.
  document.addEventListener('click', function (event) {
    var slide = event.target.closest('.index-look .look__slide');
    if (!slide) return;

    // Echte Links und Buttons normal abhandeln lassen
    if (event.target.closest('a, button')) return;

    var gridItem = slide.querySelector('[data-url]');
    if (gridItem) {
      var url = gridItem.getAttribute('data-url');
      if (url) window.location.href = url;
    }
  });


  




  // Fix: Rabattcode — Gross-/Kleinschreibung normalisieren
  // theme.js liest den Input-Wert und speichert ihn unverändert (z.B. "FREE20CHF").
  // cart-price.liquid rendert data-discount-code="{{ discount.title | downcase }}"
  // → "free20chf". Mismatch: includes() schlägt fehl → Duplikat-Eintrag im Array →
  // removeDiscount("free20chf") löscht nur den Kleinbuchstaben-Eintrag, "FREE20CHF"
  // bleibt → updateCartDiscounts("FREE20CHF") schickt Code erneut an Shopify →
  // Code wird re-applied statt entfernt.
  //
  // Fix: Input via capture-Phase lowercasen bevor theme.js ihn liest.
  // capture: true → feuert vor dem bubbling-Handler in theme.js.
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-apply-discount]')) return;
    var input = document.querySelector('[data-discount-input]');
    if (input) input.value = input.value.toLowerCase();
  }, true);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
